import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83bf5b90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 2,
  class: "emparejamientos-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Emparejamientos:", -1))
const _hoisted_4 = { class: "emparejamiento-text" }

import {
  Emparejamiento,
  GenerarRonda,
  JugadorParaEmparejamiento,
} from "@/interfaces/Live";
import {
  InscripcionTorneoCreadoDTO,
  TorneoGestionInfoDTO,
} from "@/interfaces/Torneo";
import { generarRonda } from "@/services/PartidaTorneoService";
import { ref, watch, onMounted, computed } from "vue";
import { getInfoTorneoCreado } from "@/services/TorneosService";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalParametrosPrimeraRonda',
  props: {
    isVisible: { type: Boolean },
    torneo: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalIsVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
  }
);

const mismaComunidadCheck = ref<boolean>(false);
const mismaComunidadCheckString = ref<string>("SI");
const goodVsEvilCheck = ref<boolean>(false);
const goodVsEvilCheckString = ref<string>("SI");
const retosCheck = ref<boolean>(false);
const esEloCheck = ref<boolean>(false);
const opcionImpares = ref<string | null>(null);
const isImpares = ref<boolean>(false);
const numeroRonda = ref<number>(1);

const jugadoresObj = ref<InscripcionTorneoCreadoDTO[]>();
const jugadoresNick = ref<JugadorParaEmparejamiento[]>();
const jugador1 = ref<JugadorParaEmparejamiento>();
const jugador2 = ref<JugadorParaEmparejamiento>();

const rondas = ref<number[]>();
const isGenerating = ref<boolean>(false);
const torneoSelected = ref<TorneoGestionInfoDTO>();

const errorRonda = ref<string | null>(null);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

const emparejamientos = ref<
  { jugador1: JugadorParaEmparejamiento; jugador2: JugadorParaEmparejamiento }[]
>([]);
const isAddEmparejamientoEnabled = computed(() => {
  return jugador1.value && jugador2.value && jugador1.value !== jugador2.value;
});

watch(numeroRonda, (newValue) => {
  if (newValue) {
    errorRonda.value = null;
  }
});

onMounted(async () => {
  try {
    if (!props.torneo?.torneo.idTorneo) {
      console.error("El idTorneo no está definido");
      return;
    }
    // Obtener información del torneo creado
    const responseTorneo = await getInfoTorneoCreado(
      props.torneo?.torneo.idTorneo
    );
    torneoSelected.value = responseTorneo.data;

    // Si hay inscripciones, procesar jugadores
    if (torneoSelected.value?.inscripciones) {
      jugadoresObj.value = torneoSelected.value.inscripciones;
      isImpares.value = jugadoresObj.value?.length % 2 !== 0;

      // Usamos `for...of` para manejar promesas de manera secuencial o `map` con `Promise.all`
      jugadoresNick.value = torneoSelected.value?.inscripciones.map(
        (element) => ({
          idUsuario: element.idUsuario!,
          nick: element.nick!,
        })
      );
    }

    // Procesar rondas si existe el número de partidas
    if (torneoSelected.value?.torneo?.numeroPartidas) {
      const totalRondas = torneoSelected.value.torneo.numeroPartidas;
      rondas.value = Array.from({ length: totalRondas }, (_, i) => i + 1);
    }
  } catch (error) {
    console.error("Error al obtener la información del torneo:", error);
  }
});

const addEmparejamiento = () => {
  //Validaciones

  if (!jugador1.value || !jugador2.value) {
    alert("No puedes dejar a los jugadores en blanco");
    return;
  }

  if (jugador1.value.idUsuario === jugador2.value.idUsuario) {
    alert("No puedes emparejar al mismo jugador.");
    return;
  }

  const isJugador1InEmparejamientos: boolean = emparejamientos.value.some(
    (emparejamiento) =>
      emparejamiento.jugador1.idUsuario === jugador1.value!.idUsuario ||
      emparejamiento.jugador2.idUsuario === jugador1.value!.idUsuario
  );
  const isJugador2InEmparejamientos: boolean = emparejamientos.value.some(
    (emparejamiento) =>
      emparejamiento.jugador1.idUsuario === jugador2.value!.idUsuario ||
      emparejamiento.jugador2.idUsuario === jugador2.value!.idUsuario
  );

  if (isJugador1InEmparejamientos || isJugador2InEmparejamientos) {
    alert("Uno o ambos jugadores ya están emparejados.");
    return;
  }

  const emparejamientoTerminado: Emparejamiento = {
    jugador1: jugador1.value,
    jugador2: jugador2.value,
  };
  emparejamientos.value.push(emparejamientoTerminado);

  jugador1.value = undefined;
  jugador2.value = undefined;
};

const removeEmparejamiento = (index: number) => {
  emparejamientos.value.splice(index, 1);
};

const confirmarConfiguracion = async () => {
  if (!numeroRonda.value) {
    errorRonda.value = "El número de ronda es obligatorio.";
    return;
  }
  if (!props.torneo?.torneo.idTorneo) {
    console.error("El idTorneo no está definido");
    return;
  }

  errorRonda.value = null;
  if (mismaComunidadCheckString.value === "SI")
    mismaComunidadCheck.value = true;
  else mismaComunidadCheck.value = false;

  if (goodVsEvilCheckString.value === "SI") goodVsEvilCheck.value = true;
  else goodVsEvilCheck.value = false;

  const configuracion: GenerarRonda = {
    mismaComunidadCheck: mismaComunidadCheck.value,
    luzVsOscCheck: goodVsEvilCheck.value,
    retosCheck: retosCheck.value,
    emparejamientos: emparejamientos.value,
    esEloCheck: esEloCheck.value,
    opcionImpares: opcionImpares.value,
    idTorneo: props.torneo?.torneo.idTorneo,
    idRonda: numeroRonda.value!,
  };

  try {
    isGenerating.value = true;

    await generarRonda(configuracion);
    showSuccessModal.value = true;
  } catch (error) {
    showErrorModal.value = true;
    console.error(error);
  } finally {
    isGenerating.value = false;
  }

  emit("confirm", configuracion);
  closeModal();
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Configurar Ronda")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                      inline: "",
                      modelValue: mismaComunidadCheckString.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mismaComunidadCheckString).value = $event)),
                      label: "¿Se permiten emparejamientos de la misma comunidad de juego?"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "SI",
                          value: "SI"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "NO",
                          value: "NO"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_radio_group, {
                      inline: "",
                      modelValue: goodVsEvilCheckString.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((goodVsEvilCheckString).value = $event)),
                      label: "¿Prevalece luz vs oscuridad?"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "SI",
                          value: "SI"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "NO",
                          value: "NO"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (isImpares.value)
                      ? (_openBlock(), _createBlock(_component_v_radio_group, {
                          key: 0,
                          modelValue: opcionImpares.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((opcionImpares).value = $event)),
                          label: "Los jugadores son impares. ¿Cómo quieres gestionarlo?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: "Hacer un bye",
                              value: "bye"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_checkbox, {
                      modelValue: retosCheck.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((retosCheck).value = $event)),
                      label: "¿Tenemos algún reto para esta ronda?"
                    }, null, 8, ["modelValue"]),
                    (retosCheck.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createVNode(_component_v_combobox, {
                            modelValue: jugador1.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((jugador1).value = $event)),
                            items: jugadoresNick.value,
                            "item-title": "nick",
                            "item-value": "idUsuario",
                            label: "Jugador 1"
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_combobox, {
                            modelValue: jugador2.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((jugador2).value = $event)),
                            items: jugadoresNick.value,
                            "item-title": "nick",
                            "item-value": "idUsuario",
                            label: "Jugador 2"
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_btn, {
                            disabled: !isAddEmparejamientoEnabled.value,
                            variant: "tonal",
                            color: "blue",
                            onClick: addEmparejamiento
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Agregar Emparejamiento")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_divider, { class: "my-3" }),
                    (emparejamientos.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _hoisted_3,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emparejamientos.value, (emparejamiento, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "emparejamiento-item"
                            }, [
                              _createElementVNode("span", _hoisted_4, " Mesa " + _toDisplayString(index + 1) + ": " + _toDisplayString(emparejamiento.jugador1.nick) + " vs " + _toDisplayString(emparejamiento.jugador2.nick), 1),
                              _createVNode(_component_v_btn, {
                                class: "remove-btn",
                                onClick: ($event: any) => (removeEmparejamiento(index)),
                                icon: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-delete")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "my-4 ga-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      disabled: isGenerating.value,
                      onClick: confirmarConfiguracion,
                      color: "primary",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Generar ronda")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "secondary",
                      onClick: closeModal,
                      large: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancelar")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Ronda generada correctamente.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido generarla ronda. Intentalo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})